import basic from '../basic/pt'
export default {
    ...basic,
    ...{

    },
}